module.exports = __webpack_public_path__ + "static/media/iconCalendar.b64be267.svg";